import Vue from 'vue'
import axios from 'axios'

const api = axios.create({
	headers: { 'X-Requested-With': 'XMLHttpRequest' },
	withCredentials: true
})

api.interceptors.response.use(
	(response) => {
		return response
	},
	(error) => {
		const vm = new Vue()

		console.error(error)

		if (
			error.response.status === 401
			&& error.response.data.hasOwnProperty('message')
			&& error.response.data.message === 'Unauthenticated.'
		) {
			// User is not authenticated, redirect back to force a login
			window.location.replace('/')
		}

		return Promise.reject(error)
	}
)

export default api
